import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/ShiftActions";
import * as api from "../../api/ShiftApi";
import { showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getShiftList() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getShifts();
        yield put(actions.setShifts(data || undefined));
    } catch (error) {
        yield put(actions.setShifts(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}


function* watchAll() {
    yield takeEvery(actions.Types.GET_SHIFTS, getShiftList);
}

const ShiftSaga = [fork(watchAll)];

export default ShiftSaga;